export const MASK_PHONE = {
  mask: '9999 999999',
  maskChar: '',
  placeholder: 'XXXX XXXXXX',
};
export const MASK_SMS_CODE = {
  mask: '9999',
  maskChar: '',
  placeholder: 'XXXX',
};
export const MASK_ID_NUMBER = {
  mask: '99999999',
  maskChar: '',
};
export const MASK_DATE = {
  mask: '39.19.2999',
  formatChars: {
    1: '[0-1]',
    2: '[1-2]',
    3: '[0-3]',
    9: '[0-9]',
  },
  maskChar: '',
  dateFormat: 'dd.MM.yyyy',
};

export const MASK_PAN_CARD_NUMBER = {
  mask: 'aaaa a999 9a',
  maskChar: ' ',
  placeholder: 'XXXX XXXXX XX',
};

export const MASK_AADHAAR_NUMBER = {
  mask: '9999 9999 9999',
  maskChar: '',
  placeholder: 'XXXX XXXX XXXX',
};

export const MASK_IFSC_CODE = {
  mask: 'aaaa9******',
  maskChar: '',
  placeholder: 'XXXXXXXXXXX',
};
